
export default () => {
  const $root = $('.feedback');
  const $form = $root.find('.feedback__form');
  const $input = $root.find('.feedback__phone');
  const $error = $form.find('.feedback__error');
  const $checkbox = $form.find('.feedback__check');
  const errorCheckbox = 'Чтобы продолжить, установите флажок';
  const errorPhone = 'Введите полный номер телефона';


  $input.on('input', (e) => {
    if($input.val().length > 0) {
      $input.addClass('feedback__phone--not-empty');
    } else {
      $input.removeClass('feedback__phone--not-empty');
    }
    $error.removeClass('feedback__error--show');
  });

  $checkbox.on('change', () => {
    if($checkbox.is(':checked') === true) {
      $error.removeClass('feedback__error--show');
    }
  });

  function showError(text) {
    $error.html(text);
    $error.addClass('feedback__error--show');
  }

  function hideError() {
    $error.html('');
    $error.removeClass('feedback__error--show');
  }

  $form.on('submit', (e) => {
    e.preventDefault();
    const $inputs = $form.find('.feedback__phone');

    if($checkbox.is(':checked') === true){
      if($input.val().length !== 16){
        showError(errorPhone);
      } else {
        hideError();
        $.ajax({
          type: "post",
          url: $form.attr('action'),
          data: $form.serialize(),
          success: function (data) {
            $inputs.val('');
            $inputs.removeClass('feedback__phone--not-empty');
            location.href = 'https://premium.estate/top-complex/thankyoupage';
          },
        })
      }
    } else {
      showError(errorCheckbox);
    }
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/new-landing-constructor/feedback/index.js